export const makeLastWorkExperienceStartMonthFieldValue = (
  lastWorkExperienceStartMonth?: unknown,
  lastWorkExperienceStartYear?: unknown,
) => {
  const month = String(lastWorkExperienceStartMonth || '').replace(/\D/g, '');
  const year = String(lastWorkExperienceStartYear || '').replace(/\D/g, '');

  if (month || year) {
    const formattedMonth = month ? String(month).padStart(2, '0') : '__';
    const formattedYear = year ? String(year).padStart(4, '_') : '____';
    return `${formattedMonth}.${formattedYear}`;
  }

  return `__.____`;
};
